import React from 'react';
import { SolutionContextContainerProps } from './solutionContextProps';
import { SolutionContextController } from './solutionContextInterface';
import { ChatContainerBaseConfig } from '../../../../../base';
import { createSolutionContextLoader } from './solutionContextLoader';

export function createSolutionContextContainer(
    config: ChatContainerBaseConfig,
    controller: SolutionContextController
): React.FC<SolutionContextContainerProps> {
    const {
        context: { useContext },
    } = config;

    const loader = createSolutionContextLoader(config);

    return ({ as: View, ...containerProps }) => {
        const context = useContext();
        const item = loader.useLoad(context);
        const props = controller.useProps(context, item, {
            onSelect: containerProps.onSelect,
            onBack: containerProps.onBack,
        });
        return <View {...props} />;
    };
}
